export const lfBrown = {
    '400': '#8D795E',
    '800': '#2a241c',

}

export const lfGreen = {
    '100': '#dee7d0',
    '200': '#afc097',
    '300': '#4F9850',

    '400': '#72ac72',
    '800': '#798961',

}

export const lfTan = {
    '100': '#F7E7CE',
}


// WEBPACK FOOTER //
// ./src/Components/lfColors.js